export var PUB_SUB_CHANNEL_APP = 'app';
export var PUB_SUB_CHANNEL_MODAL = 'modal';
export var PUB_SUB_CHANNEL_MEMBER_DRAFTS = 'member-drafts';
export var PUB_SUB_CHANNEL_MEMBER_LIKES = 'member-likes';
export var PUB_SUB_CHANNEL_MEMBER_POSTS = 'member-posts';
export var PUB_SUB_CHANNEL_MEMBER_COMMENTS = 'member-comments';
